import { render, staticRenderFns } from "./PageSeckillForm.vue?vue&type=template&id=7c061fd9&scoped=true"
import script from "./PageSeckillForm.vue?vue&type=script&lang=js"
export * from "./PageSeckillForm.vue?vue&type=script&lang=js"
import style0 from "./PageSeckillForm.vue?vue&type=style&index=0&id=7c061fd9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c061fd9",
  null
  
)

export default component.exports